<template>
  <span v-if="justCopied || visible" class="inline-flex items-center">
    <span v-if="justCopied" class="text-sm text-gray-dark">{{ copiedLabel }}</span>
    <base-button
      v-else
      variant="transparent-gray"
      @mouseenter="onHover(true)"
      @mouseleave="onHover(false)"
      @click.stop="copy"
    >
      <CopyInputIcon class="text-gray-dark cursor-pointer mb-1" :size="iconSize"/>
    </base-button>
  </span>
</template>

<script>
import CopyInputIcon from '@/assets/images/icons/CopyInputIcon.vue'

export default {
  name: 'CopyButton',

  components: { CopyInputIcon },

  props: {
    text: {
      type: String,
      required: true
    },
    copiedLabel: {
      type: String,
      default: 'Copied!'
    },
    visible: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: [Number, String],
      default: 16
    }
  },

  data() {
    return {
      justCopied: false,
      copyFeedbackTimeout: null
    }
  },

  beforeDestroy() {
    if (this.copyFeedbackTimeout) clearTimeout(this.copyFeedbackTimeout)
  },

  methods: {
    onHover(isHovered) {
      this.$emit('hover', isHovered)
    },

    copy() {
      return this.$copyText(this.text).then(() => {
        this.onHover(false)
        this.justCopied = true
        if (this.copyFeedbackTimeout) clearTimeout(this.copyFeedbackTimeout)
        this.copyFeedbackTimeout = setTimeout(() => {
          this.justCopied = false
          this.copyFeedbackTimeout = null
        }, 3000)
      })
    }
  }
}
</script>
